import { GET } from './api';

const table = 'log-cobrancas';

// Auditoria automatica: o backend grava os logs sozinho.
// Create, Update e Delete retornam 403, por isso o servico e somente leitura.
export const Read = async (filters = '') => {
  return await GET(`/${table}${filters}`, true);
};

export const ReadOne = async (id) => {
  return await GET(`/${table}/${id}?populate=*`, true);
};

export const ReadByCobranca = async (id, filters = '') => {
  return await GET(
    `/${table}?filters[cobranca][id][$eq]=${id}&sort=data:desc${filters}`,
    true
  );
};

// Logs de renegociacao concluida. O mesmo registro liga as duas pontas:
// `relation = 'cobranca'` busca pela original, `'cobranca_nova'` pela gerada.
// Logs anteriores a 20/10/2026 nao tem `cobranca_nova` e so aparecem pela
// original.
export const ReadRenegotiationLogs = async (id, relation = 'cobranca') => {
  return await GET(
    `/${table}?filters[acao][$eq]=renegociacao&filters[${relation}][id][$eq]=${id}&sort=data:desc`,
    true
  );
};

// Logs de acoes que atingem uma parcela especifica. Acoes de contrato
// (criacao, importacao, alteracao de status) nao tem titulo e ficam de fora.
export const ReadByTitulo = async (id, filters = '') => {
  return await GET(
    `/${table}?filters[titulo][id][$eq]=${id}&sort=data:desc${filters}`,
    true
  );
};

// Logs de uma acao a partir de uma data, de todos os contratos do escopo do
// usuario. Serve de trilha de auditoria para os relatorios (quem fez, por qual
// origem), e nao para somar totais: ver o comentario de services/titulo.js.
export const ReadByActionSince = async (acao, since, page = 1) => {
  return await GET(
    `/${table}?filters[acao][$eq]=${acao}&filters[data][$gte]=${since}&sort=data:desc&pagination[page]=${page}&pagination[pageSize]=1000`,
    true
  );
};

// Logs de varias acoes a partir de um instante (ISO), de todos os contratos do
// escopo do usuario. O `$in` e indexado para nao repetir a chave na query.
export const ReadByActionsSince = async (acoes, since, page = 1) => {
  const actions = acoes
    .map((acao, index) => `filters[acao][$in][${index}]=${acao}`)
    .join('&');
  return await GET(
    `/${table}?${actions}&filters[data][$gte]=${since}&sort=data:asc&pagination[page]=${page}&pagination[pageSize]=1000`,
    true
  );
};
